import mitt from "mitt";
class eventBus {
  constructor() {
    this.emitter = mitt();
  }
  $on(eventName, callback) {
    this.emitter.on(eventName, callback);
  }
  $off(eventName, callback) {
    this.emitter.off(eventName, callback);
  }
  $emit(eventName, arg) {
    this.emitter.emit(eventName, arg);
  }
}
const legoEventBus = new eventBus();
export default legoEventBus;
